import { render, staticRenderFns } from "./AddContainer.vue?vue&type=template&id=cf8d1460&scoped=true"
import script from "./AddContainer.vue?vue&type=script&lang=ts"
export * from "./AddContainer.vue?vue&type=script&lang=ts"
import style0 from "./AddContainer.vue?vue&type=style&index=0&id=cf8d1460&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf8d1460",
  null
  
)

export default component.exports